import { isEqual } from 'lodash';
import { getColumnByFilterParam } from '../../../utils/managerUtils';
import { getDefaultLazyStateFilters } from '../../../utils/getDefaultLazyStateFilters';

export const updateLazyStateFromActiveFilters = (
  oldLazyState,
  activeFilters,
  dataset,
  filter
) => {
  const newFilters = getDefaultLazyStateFilters(dataset, filter);
  if (activeFilters) {
    Object.keys(activeFilters).forEach((key) => {
      const columnWithThisFilter = getColumnByFilterParam(key, dataset);
      if (columnWithThisFilter) {
        const matchMode = Object.keys(activeFilters[key])[0];
        const value = activeFilters[key][matchMode];
        newFilters[columnWithThisFilter.name] = {
          operator: 'and',
          constraints: [{ matchMode, value }],
        };
      }
    });
  }
  return isEqual(oldLazyState.filters, newFilters)
    ? oldLazyState
    : { ...oldLazyState, filters: newFilters };
};
